// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/Images/white-menu-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-layout-header {
  height: auto;
  padding: 0 25px;
}
.ant-layout-header .menuWrapper {
  display: flex;
  align-items: end;
  justify-content: flex-start;
  gap: 200px;
}
.ant-layout-header h1.page-title {
  font-size: 28px !important;
  font-weight: 500;
  text-align: left;
  color: #c11b2f;
  text-transform: capitalize;
  margin: 0;
  line-height: 1;
  height: 100%;
  display: flex;
  align-items: center;
}
.ant-layout-header .ant-row {
  height: 100%;
}
.ant-layout-header .ant-breadcrumb-link a {
  background-color: unset !important;
}
.ant-layout-header .top-header-menu {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  border: none;
  background-color: transparent;
}
.ant-layout-header .top-header-menu li {
  height: auto;
  width: auto;
  margin-bottom: 0px !important;
}
.ant-layout-header .top-header-menu li a {
  display: flex;
  align-items: center;
  width: 100%;
  transition: all 0.4s ease-in-out;
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  column-gap: 4px;
  padding: 15px 30px;
  z-index: 2;
  position: relative;
}
.ant-layout-header .top-header-menu li a span {
  line-height: 1;
}
.ant-layout-header .top-header-menu li a:hover {
  color: #c11b2f !important;
}
.ant-layout-header .top-header-menu li a .menu-icon {
  display: none;
}
.ant-layout-header .top-header-menu li a svg {
  display: none;
}
.ant-layout-header .top-header-menu li.ant-menu-item-selected,
.ant-layout-header .top-header-menu li:hover {
  position: relative;
  background-color: transparent !important;
  border-radius: 8px 8px 0px 0px !important;
}
.ant-layout-header .top-header-menu li.ant-menu-item-selected:before,
.ant-layout-header .top-header-menu li:hover:before {
  opacity: 1;
}
.ant-layout-header .top-header-menu li.ant-menu-item-selected a,
.ant-layout-header .top-header-menu li:hover a {
  color: #c11b2f !important;
}
.ant-layout-header .top-header-menu li.ant-menu-item-selected svg path,
.ant-layout-header .top-header-menu li:hover svg path {
  stroke: #c11b2f !important;
}
.ant-layout-header .top-header-menu li:before {
  content: "";
  position: absolute;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center;
  opacity: 0;
  transition: all 0.3s ease-in-out;
}
.userProfileWrapper {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
  gap: 28px;
}
.userProfileWrapper .cont {
  display: flex;
  align-items: center;
  gap: 20px;
}
.userProfileWrapper .cont .profileImageWrapper {
  height: 34px;
  width: 34px;
  border-radius: 50%;
  overflow: hidden;
  border: 2px solid #c11b2f;
  position: relative;
}
.userProfileWrapper .cont .profileImageWrapper img {
  object-fit: cover;
  object-position: center;
  height: 100%;
  width: 100%;
}
.userProfileWrapper .cont p {
  color: #000000;
  font-family: "Poppins", sans-serif;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0em;
  line-height: 1;
  margin: 0;
  padding: 0;
}
.userProfileWrapper .ant-badge {
  cursor: pointer;
}
.profile-dropdown ul {
  width: 200px;
  border-radius: 5px !important;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15) !important;
  padding: 0 !important;
  overflow: hidden;
}
.profile-dropdown ul li {
  line-height: 1 !important;
  padding: 15px 15px !important;
  overflow: hidden !important;
  border-bottom: 1px solid #555b6d45;
  border-radius: unset !important;
}
.profile-dropdown ul li a {
  cursor: pointer;
  color: #000000;
  font-size: 14px;
  font-weight: 400;
  font-family: "Poppins", sans-serif;
  display: inline-block;
  width: 100%;
}
.profile-dropdown ul li:last-child a {
  border-bottom: none;
}
.profile-dropdown ul li:hover {
  background-color: transparent;
}
.profile-dropdown ul li .anticon {
  font-size: 14px !important;
}
.notificationWrapper {
  max-height: 400px;
  width: 400px;
  overflow: auto;
}
.notificationWrapper .cont {
  display: grid;
  grid-template-columns: 50px 1fr;
  align-items: center;
  border-bottom: 1px solid #ccc;
  padding: 12px 10px 12px 0;
  margin-right: 10px;
}
.notificationWrapper .cont .right {
  height: 20px;
  width: 20px;
}
.notificationWrapper .cont .mid p {
  margin: 0;
  color: #a2a1a1;
  font-weight: 400;
  font-size: 14px;
  padding-bottom: 0;
}
.notificationWrapper .cont .mid h4 {
  font-size: 18px;
  color: #3a3a3c;
  font-weight: 500;
  margin-top: 0;
  margin-bottom: 0;
  line-height: 1;
  padding-bottom: 4px;
}
.notificationWrapper .cont .left {
  display: flex;
  align-items: center;
}
.notificationWrapper .cont .left img {
  object-fit: cover;
  border-radius: 50%;
  border: 2px solid #ccc;
}
.notificationWrapper a:last-child .cont {
  border-bottom-color: transparent;
}
.notification-clear-all button {
  margin: 0 !important;
  margin-top: 10px !important;
  background-color: transparent !important;
  border: none !important;
  font-size: 14px;
}
.notification-clear-all {
  text-align: right;
}
.ant-popover-title {
  font-size: 18px;
  font-weight: 500 !important;
  color: #c11b2f !important;
  margin-bottom: 0;
  text-align: center;
}
.headerWrapper {
  position: relative;
  background-color: #ffffff !important;
  padding: 20px 20px !important;
  z-index: 1111;
}
.headerWrapper .user-profile {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
}
.headerWrapper ol li span {
  color: #a3a3a3;
}
.headerWrapper .gx-linebar {
  background-color: #9a9a9a;
  width: 38px;
  height: 38px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  transition: all ease-in-out 0.3s;
}
.headerWrapper .gx-linebar .gx-icon-btn:focus,
.headerWrapper .gx-linebar .gx-icon-btn:hover {
  background: none;
}
.headerWrapper .gx-linebar:hover {
  background-color: #c11b2f;
}
.headerWrapper .left {
  display: flex;
  align-items: center;
  height: 100%;
  gap: 15px;
  max-width: -moz-fit-content;
  max-width: fit-content;
}
.headerWrapper .left .ant-space {
  height: 100%;
}
.headerWrapper .left .img {
  display: flex;
  align-items: center;
  height: 40px;
  width: 40px;
  overflow: hidden;
  border-radius: 50%;
}
.headerWrapper .left .img img {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
}
.headerWrapper.customer {
  background-color: #c11b2f !important;
  padding: 15px 20px 0px !important;
  line-height: 42px !important;
}
.mobileHeaderWrapper {
  display: none;
}
@media (min-width: 1281px) and (max-width: 1599px) {
  .ant-layout-header .menuWrapper {
    gap: 40px;
  }
  .ant-layout-header .menuWrapper .top-header-menu li a {
    font-size: 14px;
    padding: 12px 20px;
  }
}
@media (min-width: 1025px) and (max-width: 1280px) {
  .headerWrapper.customer .menuWrapper .headerLogo img {
    width: 110px;
    height: auto;
  }
  .ant-layout-header h5.title {
    font-size: 22px;
  }
  .ant-layout-header .menuWrapper {
    gap: 0px;
  }
  .ant-layout-header .menuWrapper .top-header-menu li {
    padding-inline: 10px;
  }
  .ant-layout-header .menuWrapper .top-header-menu li a {
    font-size: 14px;
    padding: 12px 12px;
  }
}
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .ant-layout-header h5.title {
    font-size: 20px;
  }
}
@media (max-width: 1025px) {
  .headerWrapper.customer {
    display: none;
  }
  .mobileHeaderWrapper {
    display: block;
  }
  .mobileHeaderWrapper .mobileMenuTop {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 20px;
    background-color: #c11b2f;
  }
  .mobileHeaderWrapper .mobileMenuTop button {
    padding: 10px !important;
    border-radius: 4px !important;
  }
  .mobileHeaderWrapper .mobileMenuTop .headerLogo img {
    width: 120px;
    height: auto;
  }
  .mobileHeaderWrapper .headerMenu {
    right: -300px;
    position: fixed;
    transition: 0.5s;
    width: 300px;
    height: 100vh;
    z-index: 10;
    top: 0;
    background-color: #ffffff;
  }
  .mobileHeaderWrapper .headerMenu .mobileMenuTop {
    padding: 10px;
    display: flex;
    justify-content: flex-end;
    background-color: #ffffff;
  }
  .mobileHeaderWrapper .headerMenu ul li {
    border-top: 1px solid #c11b2f;
    border-radius: 0;
    margin-top: 0;
    margin-bottom: 0;
  }
  .mobileHeaderWrapper .headerMenu ul li span {
    font-size: 14px;
    color: #c11b2f;
  }
  .mobileHeaderWrapper .headerMenu ul li span .menu-icon {
    display: none;
  }
  .mobileHeaderWrapper .headerMenu ul li span svg {
    display: none;
  }
  .mobileHeaderWrapper .headerMenu ul .ant-menu-item-selected {
    background-color: #c11b2f;
  }
  .mobileHeaderWrapper .headerMenu ul .ant-menu-item-selected span {
    color: #ffffff;
  }
  .mobileHeaderWrapper .open {
    right: 0px;
    box-shadow: 0px 0px 10px #0000000f;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .headerWrapper.ant-layout-header .title {
    font-size: 20px !important;
  }
}
@media (max-width: 991px) {
  .headerWrapper {
    padding: 15px 45px !important;
  }
}
@media (min-width: 481px) and (max-width: 767px) {
  .headerWrapper {
    padding: 15px 45px !important;
  }
  .headerWrapper.ant-layout-header .title {
    font-size: 20px !important;
  }
}
@media (min-width: 280px) and (max-width: 480px) {
  .headerWrapper {
    padding: 15px 45px !important;
    height: 55px;
  }
  .headerWrapper.ant-layout-header h1.page-title {
    font-size: 14px !important;
  }
  .headerWrapper .userProfileWrapper {
    display: grid;
    gap: 10px;
  }
  .headerWrapper .userProfileWrapper .ant-badge svg {
    height: 25px;
    width: 29px;
  }
  .headerWrapper .userProfileWrapper .cont {
    gap: 10px;
  }
  .headerWrapper .userProfileWrapper .cont .profileImageWrapper {
    height: 28px;
    width: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .headerWrapper .userProfileWrapper .cont p {
    font-size: 14px;
  }
  .headerWrapper .left {
    display: grid;
    grid-template-columns: 38px auto;
    gap: 10px;
  }
  .headerWrapper .left .img {
    height: 36px;
    width: 36px;
  }
  .ant-popover-title {
    font-size: 16px;
    min-width: unset !important;
  }
  .notificationWrapper {
    width: 260px;
  }
  .notificationWrapper .cont {
    grid-template-columns: 50px 1fr;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .notificationWrapper .cont .mid h4 {
    font-size: 16px;
  }
  .notificationWrapper .cont .mid p {
    font-size: 12px;
    line-height: 1.2;
  }
}
`, "",{"version":3,"sources":["webpack://./src/layout/TopHeader/Header.less"],"names":[],"mappings":"AAEA;EACE,YAAA;EACA,eAAA;AADF;AADA;EAII,aAAA;EACA,gBAAA;EACA,2BAAA;EACA,UAAA;AAAJ;AAPA;EAUI,0BAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,0BAAA;EACA,SAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AAAJ;AAnBA;EAsBI,YAAA;AAAJ;AAtBA;EA0BM,kCAAA;AADN;AAzBA;EA+BI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,6BAAA;AAHJ;AAhCA;EAsCM,YAAA;EACA,WAAA;EACA,6BAAA;AAHN;AArCA;EA0CQ,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;AAFR;AAlDA;EAsDU,cAAA;AADV;AAGQ;EACE,yBAAA;AADV;AAxDA;EA4DU,aAAA;AADV;AA3DA;EA+DU,aAAA;AADV;AAKM;;EAEE,kBAAA;EACA,wCAAA;EACA,yCAAA;AAHR;AAIQ;;EACE,UAAA;AADV;AALM;;EASI,yBAAA;AAAV;AATM;;EAcM,0BAAA;AADZ;AAKM;EACE,WAAA;EACA,kBAAA;EACA,oEAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,4BAAA;EACA,0BAAA;EACA,2BAAA;EACA,UAAA;EACA,gCAAA;AAHR;AASA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,SAAA;AAPF;AAEA;EAOI,aAAA;EACA,mBAAA;EACA,SAAA;AANJ;AAHA;EAWM,YAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;AALN;AAXA;EAkBQ,iBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;AAJR;AAjBA;EAyBM,cAAA;EACA,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,SAAA;EACA,UAAA;AALN;AA3BA;EAoCI,eAAA;AANJ;AAUA;EAEI,YAAA;EAEA,6BAAA;EACA,uDAAA;EACA,qBAAA;EACA,gBAAA;AAVJ;AAGA;EASM,yBAAA;EACA,6BAAA;EACA,2BAAA;EACA,kCAAA;EACA,+BAAA;AATN;AAJA;EAeQ,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kCAAA;EACA,qBAAA;EACA,WAAA;AARR;AAUM;EACE,mBAAA;AARR;AAUM;EACE,6BAAA;AARR;AAnBA;EA8BQ,0BAAA;AARR;AAaA;EACE,iBAAA;EACA,YAAA;EACA,cAAA;AAXF;AAQA;EAKI,aAAA;EACA,+BAAA;EACA,mBAAA;EACA,6BAAA;EACA,yBAAA;EACA,kBAAA;AAVJ;AAAA;EAYM,YAAA;EACA,WAAA;AATN;AAJA;EAiBQ,SAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAVR;AAXA;EAwBQ,eAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAVR;AApBA;EAkCM,aAAA;EACA,mBAAA;AAXN;AAxBA;EAqCQ,iBAAA;EACA,kBAAA;EACA,sBAAA;AAVR;AA7BA;EA6CM,gCAAA;AAbN;AAkBA;EACE,oBAAA;EACA,2BAAA;EACA,wCAAA;EACA,uBAAA;EACA,eAAA;AAhBF;AAkBA;EACE,iBAAA;AAhBF;AAkBA;EACE,eAAA;EACA,2BAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;AAhBF;AAmBA;EACE,kBAAA;EACA,oCAAA;EACA,6BAAA;EACA,aAAA;AAjBF;AAaA;EAMI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;AAhBJ;AAOA;EAcQ,cAAA;AAlBR;AAIA;EAmBI,yBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,gCAAA;AApBJ;AALA;;EA4BM,gBAAA;AAnBN;AAqBI;EACE,yBAAA;AAnBN;AAZA;EAoCI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EAAA,sBAAA;AArBJ;AAnBA;EA0CM,YAAA;AApBN;AAtBA;EA6CM,aAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AApBN;AA9BA;EAoDQ,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;AAnBR;AAuBE;EACE,oCAAA;EACA,iCAAA;EACA,4BAAA;AArBJ;AAyBA;EACE,aAAA;AAvBF;AAoCA;EACE;IAEI,SAAA;EAnCJ;EAiCA;IAMU,eAAA;IACA,kBAAA;EApCV;AACF;AA6CA;EACE;IAIQ,YAAA;IACA,YAAA;EA9CR;EAmDA;IAEI,eAAA;EAlDJ;EAgDA;IAKI,QAAA;EAlDJ;EA6CA;IAQQ,oBAAA;EAlDR;EA0CA;IAUU,eAAA;IACA,kBAAA;EAjDV;AACF;AA0DA;EACE;IAEI,eAAA;EAzDJ;AACF;AA8DA;EACE;IACE,aAAA;EA5DF;EA8DA;IACE,cAAA;EA5DF;EA2DA;IAGI,aAAA;IACA,mBAAA;IACA,8BAAA;IACA,kBAAA;IACA,yBAAA;EA3DJ;EAoDA;IASM,wBAAA;IACA,6BAAA;EA1DN;EAgDA;IAeQ,YAAA;IACA,YAAA;EA5DR;EA4CA;IAqBI,aAAA;IACA,eAAA;IACA,gBAAA;IACA,YAAA;IACA,aAAA;IACA,WAAA;IACA,MAAA;IACA,yBAAA;EA9DJ;EAkCA;IA8BM,aAAA;IACA,aAAA;IACA,yBAAA;IACA,yBAAA;EA7DN;EA4BA;IAqCQ,6BAAA;IACA,gBAAA;IACA,aAAA;IACA,gBAAA;EA9DR;EAsBA;IA0CU,eAAA;IACA,cAAA;EA7DV;EAkBA;IA6CY,aAAA;EA5DZ;EAeA;IAgDY,aAAA;EA5DZ;EAYA;IAqDQ,yBAAA;EA9DR;EASA;IAuDU,cAAA;EA7DV;EAMA;IA6DI,UAAA;IACA,kCAAA;EAhEJ;AACF;AAqEA;EAEI;IAEI,0BAAA;EArEN;AACF;AA4EA;EACE;IACE,6BAAA;EA1EF;AACF;AA+EA;EACE;IACE,6BAAA;EA7EF;EA+EE;IAEI,0BAAA;EA9EN;AACF;AAqFA;EACE;IACE,6BAAA;IACA,YAAA;EAnFF;EAqFE;IAEI,0BAAA;EApFN;EA8EA;IAWI,aAAA;IAEA,SAAA;EAvFJ;EA0EA;IAgBQ,YAAA;IACA,WAAA;EAvFR;EAsEA;IAqBM,SAAA;EAxFN;EAmEA;IAuBQ,YAAA;IACA,WAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;EAvFR;EA4DA;IA8BQ,eAAA;EAvFR;EAyDA;IAoCI,aAAA;IACA,gCAAA;IACA,SAAA;EA1FJ;EAoDA;IA0CM,YAAA;IACA,WAAA;EA3FN;EAkGA;IACE,eAAA;IACA,2BAAA;EAhGF;EAmGA;IACE,YAAA;EAjGF;EAgGA;IAGI,+BAAA;IACA,iBAAA;IACA,oBAAA;EAhGJ;EA2FA;IAQQ,eAAA;EAhGR;EAwFA;IAWQ,eAAA;IACA,gBAAA;EAhGR;AACF","sourcesContent":["@import url(\"../../assets/Styles/variables.less\");\n\n.ant-layout-header {\n  height: auto;\n  padding: 0 25px;\n  .menuWrapper {\n    display: flex;\n    align-items: end;\n    justify-content: flex-start;\n    gap: 200px;\n  }\n  h1.page-title {\n    font-size: 28px !important;\n    font-weight: 500;\n    text-align: left;\n    color: @primary-color;\n    text-transform: capitalize;\n    margin: 0;\n    line-height: 1;\n    height: 100%;\n    display: flex;\n    align-items: center;\n  }\n  .ant-row {\n    height: 100%;\n  }\n  .ant-breadcrumb-link {\n    a {\n      background-color: unset !important;\n    }\n  }\n\n  .top-header-menu {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    border: none;\n    background-color: transparent;\n\n    li {\n      height: auto;\n      width: auto;\n      margin-bottom: 0px !important;\n      a {\n        display: flex;\n        align-items: center;\n        width: 100%;\n        transition: all 0.4s ease-in-out;\n        font-size: 16px;\n        font-weight: 500;\n        color: #fff;\n        column-gap: 4px;\n        padding: 15px 30px;\n        z-index: 2;\n        position: relative;\n        span {\n          line-height: 1;\n        }\n        &:hover {\n          color: @primary-color !important;\n        }\n        .menu-icon {\n          display: none;\n        }\n        svg {\n          display: none;\n        }\n      }\n\n      &.ant-menu-item-selected,\n      &:hover {\n        position: relative;\n        background-color: transparent !important;\n        border-radius: 8px 8px 0px 0px !important;\n        &:before {\n          opacity: 1;\n        }\n        a {\n          color: @primary-color !important;\n        }\n\n        svg {\n          path {\n            stroke: @primary-color !important;\n          }\n        }\n      }\n      &:before {\n        content: \"\";\n        position: absolute;\n        background-image: url(\"../../assets/Images/white-menu-bg.png\") !important;\n        width: 100%;\n        height: 100%;\n        top: 0;\n        left: 0;\n        bottom: 0;\n        right: 0;\n        background-repeat: no-repeat;\n        background-size: 100% 100%;\n        background-position: center;\n        opacity: 0;\n        transition: all 0.3s ease-in-out;\n      }\n    }\n  }\n}\n\n.userProfileWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  height: 100%;\n  gap: 28px;\n  .cont {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n    .profileImageWrapper {\n      height: 34px;\n      width: 34px;\n      border-radius: 50%;\n      overflow: hidden;\n      border: 2px solid @primary-color;\n      position: relative;\n      img {\n        object-fit: cover;\n        object-position: center;\n        height: 100%;\n        width: 100%;\n      }\n    }\n    p {\n      color: @black-color;\n      font-family: @primary-font-family;\n      font-size: 16px;\n      font-weight: 500;\n      letter-spacing: 0em;\n      line-height: 1;\n      margin: 0;\n      padding: 0;\n    }\n  }\n  .ant-badge {\n    cursor: pointer;\n  }\n}\n\n.profile-dropdown {\n  ul {\n    width: 200px;\n    // min-height: 150px;\n    border-radius: 5px !important;\n    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15) !important;\n    padding: 0 !important;\n    overflow: hidden;\n    li {\n      line-height: 1 !important;\n      padding: 15px 15px !important;\n      overflow: hidden !important;\n      border-bottom: 1px solid #555b6d45;\n      border-radius: unset !important;\n      a {\n        cursor: pointer;\n        color: @black-color;\n        font-size: 14px;\n        font-weight: 400;\n        font-family: @primary-font-family;\n        display: inline-block;\n        width: 100%;\n      }\n      &:last-child a {\n        border-bottom: none;\n      }\n      &:hover {\n        background-color: transparent;\n      }\n      .anticon {\n        font-size: 14px !important;\n      }\n    }\n  }\n}\n.notificationWrapper {\n  max-height: 400px;\n  width: 400px;\n  overflow: auto;\n  .cont {\n    display: grid;\n    grid-template-columns: 50px 1fr;\n    align-items: center;\n    border-bottom: 1px solid #ccc;\n    padding: 12px 10px 12px 0;\n    margin-right: 10px;\n    .right {\n      height: 20px;\n      width: 20px;\n    }\n    .mid {\n      p {\n        margin: 0;\n        color: #a2a1a1;\n        font-weight: 400;\n        font-size: 14px;\n        padding-bottom: 0;\n      }\n      h4 {\n        font-size: 18px;\n        color: @primary-color-dark;\n        font-weight: 500;\n        margin-top: 0;\n        margin-bottom: 0;\n        line-height: 1;\n        padding-bottom: 4px;\n      }\n    }\n    .left {\n      display: flex;\n      align-items: center;\n      img {\n        object-fit: cover;\n        border-radius: 50%;\n        border: 2px solid #ccc;\n      }\n    }\n  }\n  a:last-child {\n    .cont {\n      border-bottom-color: transparent;\n    }\n  }\n}\n\n.notification-clear-all button {\n  margin: 0 !important;\n  margin-top: 10px !important;\n  background-color: transparent !important;\n  border: none !important;\n  font-size: 14px;\n}\n.notification-clear-all {\n  text-align: right;\n}\n.ant-popover-title {\n  font-size: 18px;\n  font-weight: 500 !important;\n  color: @primary-color !important;\n  margin-bottom: 0;\n  text-align: center;\n}\n\n.headerWrapper {\n  position: relative;\n  background-color: @white-color !important;\n  padding: 20px 20px !important;\n  z-index: 1111;\n  .user-profile {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    height: 100%;\n  }\n  ol {\n    li {\n      span {\n        color: @light-input;\n      }\n    }\n  }\n  .gx-linebar {\n    background-color: @sidebar-text-color;\n    width: 38px;\n    height: 38px;\n    border-radius: 100%;\n    display: flex;\n    align-items: center;\n    transition: all ease-in-out 0.3s;\n    .gx-icon-btn:focus,\n    .gx-icon-btn:hover {\n      background: none;\n    }\n    &:hover {\n      background-color: @primary-color;\n    }\n  }\n\n  .left {\n    display: flex;\n    align-items: center;\n    height: 100%;\n    gap: 15px;\n    max-width: fit-content;\n    .ant-space {\n      height: 100%;\n    }\n    .img {\n      display: flex;\n      align-items: center;\n      height: 40px;\n      width: 40px;\n      overflow: hidden;\n      border-radius: 50%;\n      img {\n        height: 100%;\n        width: 100%;\n        display: flex;\n        align-items: center;\n      }\n    }\n  }\n  &.customer {\n    background-color: @primary-color !important;\n    padding: 15px 20px 0px !important;\n    line-height: 42px !important;\n  }\n}\n\n.mobileHeaderWrapper {\n  display: none;\n}\n\n// MEDIA QUERY START\n\n// ##Device = HD Desktops\n// ##Screen = 1600px to higher resolution desktops\n\n@media screen and (min-width: 1600px) {\n} //  Dont delete this bracket!\n\n// ##Device = Desktops\n// ##Screen = 1281px to higher resolution desktops\n@media (min-width: 1281px) and (max-width: 1599px) {\n  .ant-layout-header {\n    .menuWrapper {\n      gap: 40px;\n      .top-header-menu {\n        li {\n          a {\n            font-size: 14px;\n            padding: 12px 20px;\n          }\n        }\n      }\n    }\n  }\n} //  Dont delete this bracket!\n\n// ##Device = Laptops, Desktops\n// ##Screen = B/w 1025px to 1280px\n@media (min-width: 1025px) and (max-width: 1280px) {\n  .headerWrapper.customer {\n    .menuWrapper {\n      .headerLogo {\n        img {\n          width: 110px;\n          height: auto;\n        }\n      }\n    }\n  }\n  .ant-layout-header {\n    h5.title {\n      font-size: 22px;\n    }\n    .menuWrapper {\n      gap: 0px;\n      .top-header-menu {\n        li {\n          padding-inline: 10px;\n          a {\n            font-size: 14px;\n            padding: 12px 12px;\n          }\n        }\n      }\n    }\n  }\n} //  1025px to 1280px (Laptops, Desktops) Dont delete this bracket!\n\n// ##Device = Tablets, Ipads (landscape)\n// ##Screen = B/w 768px to 1024px\n@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\n  .ant-layout-header {\n    h5.title {\n      font-size: 20px;\n    }\n  }\n} //  768px to 1024px (landscape) Dont delete this bracket!\n@media (max-width: 991px) {\n}\n@media (max-width: 1025px) {\n  .headerWrapper.customer {\n    display: none;\n  }\n  .mobileHeaderWrapper {\n    display: block;\n    .mobileMenuTop {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      padding: 10px 20px;\n      background-color: @primary-color;\n      button {\n        padding: 10px !important;\n        border-radius: 4px !important;\n      }\n\n      .headerLogo {\n        img {\n          width: 120px;\n          height: auto;\n        }\n      }\n    }\n    .headerMenu {\n      right: -300px;\n      position: fixed;\n      transition: 0.5s;\n      width: 300px;\n      height: 100vh;\n      z-index: 10;\n      top: 0;\n      background-color: @white-color;\n      .mobileMenuTop {\n        padding: 10px;\n        display: flex;\n        justify-content: flex-end;\n        background-color: @white-color;\n      }\n      ul {\n        li {\n          border-top: 1px solid @primary-color;\n          border-radius: 0;\n          margin-top: 0;\n          margin-bottom: 0;\n          span {\n            font-size: 14px;\n            color: @primary-color;\n            .menu-icon {\n              display: none;\n            }\n            svg {\n              display: none;\n            }\n          }\n        }\n        .ant-menu-item-selected {\n          background-color: @primary-color;\n          span {\n            color: @white-color;\n          }\n        }\n      }\n    }\n    .open {\n      right: 0px;\n      box-shadow: 0px 0px 10px @box-shadow-color;\n    }\n  }\n}\n// ##Device = Tablets, Ipads (portrait)\n// ##Screen = B/w 768px to 1024px\n@media (min-width: 768px) and (max-width: 1024px) {\n  .headerWrapper {\n    &.ant-layout-header {\n      .title {\n        font-size: 20px !important;\n      }\n    }\n  }\n} //  768px to 1024px (portrait) Dont delete this bracket!\n\n// ##Device = Low Resolution Tablets, Mobiles (Landscape)\n\n@media (max-width: 991px) {\n  .headerWrapper {\n    padding: 15px 45px !important;\n    // z-index: 0;\n  }\n}\n\n// ##Screen = B/w 481px to 767px\n@media (min-width: 481px) and (max-width: 767px) {\n  .headerWrapper {\n    padding: 15px 45px !important;\n    // z-index: 0;\n    &.ant-layout-header {\n      .title {\n        font-size: 20px !important;\n      }\n    }\n  }\n} //  481px to 767px (Landscape) Dont delete this bracket!\n\n// ##Device = Most of the Smartphones Mobiles (Portrait)\n// ##Screen = B/w 280px to 480px\n@media (min-width: 280px) and (max-width: 480px) {\n  .headerWrapper {\n    padding: 15px 45px !important;\n    height: 55px;\n    // z-index: 0;\n    &.ant-layout-header {\n      h1.page-title {\n        font-size: 14px !important;\n      }\n    }\n\n    .userProfileWrapper {\n      display: grid;\n      // grid-template-columns: 45px 1fr;\n      gap: 10px;\n      .ant-badge {\n        svg {\n          height: 25px;\n          width: 29px;\n        }\n      }\n      .cont {\n        gap: 10px;\n        .profileImageWrapper {\n          height: 28px;\n          width: 28px;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n        }\n        p {\n          font-size: 14px;\n        }\n      }\n    }\n\n    .left {\n      display: grid;\n      grid-template-columns: 38px auto;\n      gap: 10px;\n      .ant-space {\n      }\n      .img {\n        height: 36px;\n        width: 36px;\n        img {\n        }\n      }\n    }\n  }\n\n  .ant-popover-title {\n    font-size: 16px;\n    min-width: unset !important;\n  }\n\n  .notificationWrapper {\n    width: 260px;\n    .cont {\n      grid-template-columns: 50px 1fr;\n      padding-top: 10px;\n      padding-bottom: 10px;\n      .mid {\n        h4 {\n          font-size: 16px;\n        }\n        p {\n          font-size: 12px;\n          line-height: 1.2;\n        }\n      }\n    }\n  }\n} //  280px to 480px (Portrait) Dont delete this bracket!\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
